import { DATE_FORMAT } from '@common/constants/global.constants'
import { toNoonIso } from '@common/utils/date.utils'
import { Stack, styled, Typography } from '@mui/material'
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker'
import { FieldValues, useController, UseControllerProps } from 'react-hook-form'

interface DatePickerInputProps<T extends FieldValues> extends UseControllerProps<T> {
	isRequired?: boolean
	label?: string
	minDate?: Date | undefined
	maxDate?: Date | undefined
}

/**
 * Date Picker input
 * @param name
 * @param control
 * @param label
 * @param minDate
 * @param maxDate
 * @param isRequired
 * @constructor
 */
const DatePickerInput = <T extends FieldValues>(
	{
		control,
		name,
		label,
		minDate,
		maxDate,
		isRequired
	}: DatePickerInputProps<T>
) => {
	const { field } = useController({
		name,
		control,
		rules: {
			required: isRequired
		}
	})

	return (
		<Container>
			{label && (
				<Typography>
					{label}
				</Typography>
			)}
			<DatePicker
				format={DATE_FORMAT}
				value={field.value ? new Date(field.value) : null}
				minDate={minDate}
				maxDate={maxDate}
				onChange={(value) => field.onChange(toNoonIso(value))}
			/>
		</Container>
	)
}

const Container = styled(Stack)({
	rowGap: '4px'
})

const DatePicker = styled(MuiDatePicker)({
	'& .MuiPickersInputBase-root': {
		padding: '0 12px 0 8px'
	},
	'& .MuiPickersSectionList-root': {
		alignItems: 'center',
		height: '40px',
		padding: '0'
	}
})

export default DatePickerInput
